import { useReducer } from 'react';
import { configs } from '@constants/configs/configs';
import { startSpinner, stopSpinner } from '@actions/common/actionCreators';
import { SPINNER_MESSAGES_IDS } from '@constants/common/miscellaneous';
import { axiosApi } from '@services/axiosInstance';

const actions = {
    GET_CANNED_CATEGORY: 'GET_CANNED_CATEGORY',
    GET_CANNED_TEMPLATES: 'GET_CANNED_TEMPLATES',
    POST_CANNED_ADD_TEMPLATE_SUCCESS: 'POST_CANNED_ADD_TEMPLATE_SUCCESS',
    POST_CANNED_ADD_TEMPLATE_FAILURE: 'POST_CANNED_ADD_TEMPLATE_FAILURE',
    POST_CANNED_EDIT_TEMPLATE_SUCCESS: 'POST_CANNED_EDIT_TEMPLATE_SUCCESS',
    POST_CANNED_EDIT_TEMPLATE_FAILURE: 'POST_CANNED_EDIT_TEMPLATE_FAILURE',
    RESET_ALL: 'RESET_ALL',
};

function reducer(state, { type, payload }) {
    switch (type) {
        case actions.GET_CANNED_CATEGORY:
            return {
                ...state,
                cannedCategory: payload,
            };
        case actions.GET_CANNED_TEMPLATES:
            return {
                ...state,
                templateList: payload,
            };
        case actions.POST_CANNED_ADD_TEMPLATE_SUCCESS:
            return {
                ...state,
                template: payload,
                postSuccess: true,
                error: false,
                errorMessage: 'Template has been created successfully',
            };
        case actions.POST_CANNED_ADD_TEMPLATE_FAILURE:
            return {
                ...state,
                postTriggeredAt: Date.now(),
                postSuccess: false,
                error: true,
                errorMessage: payload.errorMessage,
            };
        case actions.POST_CANNED_EDIT_TEMPLATE_SUCCESS:
            return {
                ...state,
                template: payload.data,
                postSuccess: true,
                error: false,
                errorMessage: 'Template has been saved successfully',
            };
        case actions.POST_CANNED_EDIT_TEMPLATE_FAILURE:
            return {
                ...state,
                postTriggeredAt: Date.now(),
                postSuccess: false,
                error: true,
                errorMessage: payload.errorMessage,
            };
        case actions.RESET_ALL:
            return {
                ...state,
                errorMessage: '',
                postSuccess: false,
                isDuplicate: false,
                error: false,
            };
        default:
            return state;
    }
}

export default () => {
    const [data, dispatch] = useReducer(reducer, {
        cannedCategory: undefined,
        templateList: undefined,
        template: {},
        postSuccess: false,
        error: false,
        errorMessage: undefined,
        postTriggeredAt: Date.now(),
    });

    const getCannedCategories = async () => {
        try {
            dispatch(startSpinner(SPINNER_MESSAGES_IDS.LOADING_DATA));
            const res = await axiosApi.get(configs.endpoints.CANNED_RESPONSES_CATEGORIES);
            if (res && res.data) {
                dispatch(stopSpinner());
                dispatch({ type: actions.GET_CANNED_CATEGORY, payload: res.data });
            }
        } catch (e) {
            dispatch(stopSpinner());
            dispatch({ type: actions.GET_CANNED_CATEGORY, payload: [] });
        }
    };

    const getCannedTemplatesList = async id => {
        try {
            const res = await axiosApi.get(configs.endpoints.CANNED_RESPONSES_TEMPLATES_LIST + id);
            if (res && res.data) {
                dispatch({ type: actions.GET_CANNED_TEMPLATES, payload: res.data });
            }
        } catch (e) {
            dispatch({ type: actions.GET_CANNED_TEMPLATES, payload: [] });
        }
    };

    const postAddNewTemplate = async data => {
        axiosApi
            .post(configs.endpoints.CANNED_RESPONSES_ADD_TEMPLATE, data)
            .then(response => {
                if (response.status === 200) {
                    dispatch({ type: actions.POST_CANNED_ADD_TEMPLATE_SUCCESS, payload: response.data });
                } else {
                    dispatch({ type: actions.POST_CANNED_ADD_TEMPLATE_FAILURE, payload: response.errorMessage });
                }
            })
            .catch(error => {
                dispatch({ type: actions.POST_CANNED_ADD_TEMPLATE_FAILURE, payload: error.response.data });
            });
    };

    const postEditTemplate = async data => {
        axiosApi
            .post(configs.endpoints.CANNED_RESPONSES_EDIT_TEMPLATE, data)
            .then(response => {
                if (response.status === 200) {
                    dispatch({ type: actions.POST_CANNED_EDIT_TEMPLATE_SUCCESS, payload: response.data });
                } else {
                    dispatch({ type: actions.POST_CANNED_ADD_TEMPLATE_FAILURE, payload: response.errorMessage });
                }
            })
            .catch(error => {
                dispatch({ type: actions.POST_CANNED_EDIT_TEMPLATE_FAILURE, payload: error.response.data });
            });
    };
    const resetAll = async () => {
        dispatch({ type: actions.RESET_ALL, payload: null });
    };
    return {
        ...data,
        getCannedCategories: () => {
            getCannedCategories();
        },
        getCannedTemplatesList: id => {
            getCannedTemplatesList(id);
        },
        postAddNewTemplate: data => {
            postAddNewTemplate(data);
        },
        postEditTemplate: data => {
            postEditTemplate(data);
        },
        resetAll: () => {
            resetAll();
        },
    };
};
